/**
 * The identifier of the sound to be played when we got an event for no audio signal.
 *
 * @type {string}
 */
export const NO_AUDIO_SIGNAL_SOUND_ID = 'NO_AUDIO_SIGNAL_SOUND_ID';
